import { Heart } from "lucide-react";
import { cn } from "@city-sage/aurum-avis-labs-components";

interface LikeButtonProps {
  isLiked: boolean;
  likeCount: number;
  onToggleLike: () => void;
  isPending?: boolean;
  theme?: 'light' | 'dark';
  layout?: 'vertical' | 'horizontal';
  className?: string;
}

export const LikeButton = ({
  isLiked,
  likeCount,
  onToggleLike,
  isPending = false,
  theme = 'light',
  layout = 'vertical',
  className
}: LikeButtonProps) => {
  const isDark = theme === 'dark';
  const isHorizontal = layout === 'horizontal';

  return (
    <button
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onToggleLike();
      }}
      disabled={isPending}
      className={cn(
        "flex items-center justify-center gap-1.5 p-1 bg-transparent border-none cursor-pointer transition-transform active:scale-95 hover:scale-105 group",
        isHorizontal ? "flex-row" : "flex-col",
        className
      )}
      aria-label={isLiked ? `Unlike (${likeCount} likes)` : `Like (${likeCount} likes)`}
      aria-pressed={isLiked}
    >
      <Heart 
        className={cn(
          "transition-colors duration-200",
          isHorizontal ? "w-5 h-5" : "w-7 h-7",
          isLiked 
            ? "fill-red-500 text-red-500" 
            : isDark 
              ? "text-white drop-shadow-md group-hover:text-gray-100" 
              : "text-gray-900 group-hover:text-gray-700"
        )} 
        strokeWidth={2}
      />
      <span className={cn(
        "font-semibold",
        isHorizontal ? "text-sm" : "text-xs",
        isDark ? "text-white drop-shadow-md" : "text-gray-900"
      )}>
        {likeCount}
      </span>
    </button>
  );
};
